export default __webpack_public_path__ + "static/media/icon_direct_selling.82e53d33.svg";